export const CREATE_CUSTOM_COLUMN = "users/custom/column/create";
export const UPDATE_CUSTOM_COLUMN = "users/custom/column/update";
export const DELETE_CUSTOM_COLUMN = "users/custom/column/delete";
export const GET_CUSTOM_COLUMN = "users/get/custom/column";
